export const m ={
    home: '首页', // 首页
    noData:'暂无数据',//暂无数据
    mobile_Please:'填写手机号',//填写手机号
    telephone_Please:'请填写正确电话号码',//请填写正确电话号码
    code_to_frequently:'发送验证码太频繁，请1小时后再试！',//发送验证码太频繁，请1小时后再试！
    batch_audit: '批量审核', // 批量审核
    cancel_audit: '取消审核', // 取消审核
    nodisables_status: '批量启用', // 批量启用
    disables_status: '批量禁用', // 批量禁用
    head_portrait: '头像', // 头像
    uplad_files: '选择文件或拖动文件到此处', // 选择文件或拖动文件到此处᠄
    uplad_audio: '选择音频文件或拖动音频文件到此处', // 选择音频文件或拖动音频文件到此处
    uplad_video: '选择视频文件或拖动视频文件到此处', // 选择视频文件或拖动视频文件到此处
    gaojian_type:'稿件类型',//稿件类型
    gaojian_number:'稿件编号',//稿件编号
    _mn:'(蒙古文)',//蒙古文
    _zh:'',//中文
    _en:'(英文)',//英文
    title:'标题',//标题
    author:'作者',//作者
    keyword:'关键词',//关键词
    abstract:'摘要',//摘要
    references:'参考文献',//参考文献
    upload_files:'上传文件',//上传文件
    download_files:'文件下载',//文件下载
    email:'邮箱',//邮箱
    phone:'手机',//手机
    copyright_statement:'著作权声明',//著作权声明
    detailed_information:'详细信息',//详细信息
    review_record:'审稿记录',//审稿记录
    stage:'阶段',//阶段
    newstage:'最新阶段',//最新阶段
    shstatus:'审核状态',//审核状态
    processing_personnel:'处理人',//处理人
    time:'时间',//时间
    processing_results:'处理结果',//处理结果
    attachment:'附件',//附件
    contributor:'作者',//作者
    contributor_time:'投稿日期',//投稿日期
    input_manuscript_comments:'请填写稿件评审意见',//请填写稿件评审意见
    review_opinion:'评审意见',//评审意见
    please_input:'请填写',//请填写
    please_select:'请选择',//请选择
    upload_instruction_file:'上传说明文件',//上传说明文件
    expert:'专家',//专家
    fpexpert:'分配初审人',//分配初审人
    zr:'ᠪᠠᠶᠢᠭᠠᠯᠢ ᠶᠢᠨ ᠰᠢᠨᠵᠢᠯᠡᠬᠦ ᠤᠬᠠᠭᠠᠨ ᠦ ᠰᠡᠳᠭᠦᠯ',//自然科学版蒙古文
    zs:'ᠭᠦᠨ ᠤᠬᠠᠭᠠᠨ ᠨᠡᠶᠢᠬᠡᠮ ᠤᠨ ᠰᠢᠨᠵᠢᠯᠡᠬᠦ ᠤᠬᠠᠭᠠᠨ ᠦ ᠰᠡᠳᠭᠦᠯ',//哲学社会科学版蒙古文
    nnsfdxxb:'ᠥᠪᠥᠷ ᠮᠣᠩᠭᠣᠯ ᠤᠨ ᠪᠠᠭᠰᠢ ᠶᠢᠨ ᠶᠡᠬᠡ ᠰᠤᠷᠭᠠᠭᠤᠯᠢ ᠶᠢᠨ ᠡᠷᠳᠡᠮ ᠰᠢᠨᠵᠢᠯᠡᠭᠡᠨ ᠦ ᠰᠡᠳᠭᠦᠯ',//内蒙古师范大学学报
    reviewer:'初审人',//初审人
    selectpsr:'选择评审人员',//选择评审人员
    psr:'评审人员',//选择评审人员




}
